<template>
  <div>
    <CTabs
      :vertical="vertical"
      :variant="variant"
      add-nav-wrapper-classes="website-tabs"
      @update:activeTab="handleActiveTab"
    >
      <!-- Privacy and Terms -->
      <CTab>
        <template slot="title">
          <div class="d-flex align-items-center">
            <img
              :src="require(`@/assets/img/flags/pt-br.svg`)"
              alt="Bandeira Brasileira"
              class="flag mr-2"
            />
            Português
          </div>
        </template>

        <CRow class="mt-4 mb-4">
          <CCol col="12">
            <div class="form-group">
              <h5 for="privacy-policy">
                <b>Políticas de Privacidade</b>
              </h5>
              <p>
                Preencha as Políticas de Privacidade do projeto em Português.
              </p>
              <TextEditor
                id="privacy-policy"
                v-model="form.privacy_policy"
                type="text"
              />
            </div>
          </CCol>
        </CRow>
      </CTab>

      <CTab>
        <template slot="title">
          <div class="d-flex align-items-center">
            <img
              :src="require(`@/assets/img/flags/en.svg`)"
              alt="Bandeira Inglesa"
              class="flag mr-2"
            />
            Inglês
          </div>
        </template>

        <CRow class="mt-4 mb-4">
          <CCol col="12">
            <div class="form-group">
              <h5 for="privacy-policy">
                <b>Políticas de Privacidade</b>
              </h5>
              <p>
                Preencha as Políticas de Privacidade do projeto em Inglês.
              </p>
              <TextEditor
                id="privacy-policy-en"
                v-model="form.privacy_policy_en"
                type="text"
              />
            </div>
          </CCol>
        </CRow>
      </CTab>

      <CTab>
        <template slot="title">
          <div class="d-flex align-items-center">
            <img
              :src="require(`@/assets/img/flags/es.svg`)"
              alt="Bandeira Espanhola"
              class="flag mr-2"
            />
            Espanhol
          </div>
        </template>

        <CRow class="mt-4 mb-4">
          <CCol col="12">
            <div class="form-group">
              <h5 for="privacy-policy">
                <b>Políticas de Privacidade</b>
              </h5>
              <p>
                Preencha as Políticas de Privacidade do projeto em Espanhol.
              </p>
              <TextEditor
                id="privacy-policy-es"
                v-model="form.privacy_policy_es"
                type="text"
              />
            </div>
          </CCol>
        </CRow>
      </CTab>
    </CTabs>

    <!-- Actions -->
    <CRow v-if="activeTabIndex !== cmsTabIndex">
      <CCol
        lg="12"
        class="d-flex justify-content-end align-items-center mt-2"
      >
        <a
          href="javascript:void(0)"
          class="mr-3"
          @click="resetForm"
        >Limpar Alterações</a>
        <CButton
          color="success"
          :disabled="processing"
          @click="send"
        >
          {{ processing ? 'Salvando...' : 'Salvar' }}
        </CButton>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import TextEditor from '@/components/ui/TextEditor'
import { cloneDeep } from 'lodash'
import SettingsService from '@/services/settings.service'

export default {
  components: {
    TextEditor
  },

  data() {
    return {
      vertical: false,
      variant: 'tabs',
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      settings: {
        // Privacy
        privacy_policy: '',
        privacy_policy_en: '',
        privacy_policy_es: ''
      },
      form: {},
      processing: false,
      activeTabIndex: 0,
      cmsTabIndex: 7
    }
  },

  created() {
    this.handlerWindowSize()
    this.getSettings()
  },

  methods: {
    selectPosition(position) {
      this.selectedImg = `positions/previews/${position}`
      this.form.cookies_notification_position = position
    },

    selectController(position) {
      this.selectedImg = `controllers/previews/${position}`
      this.form.cookies_notification_controller = position
    },

    setEnvironment(checked, event) {
      this.form.environment = event.target.value
    },

    setEnvironmentStatus(checked) {
      this.form.environment_under_maintenance = checked
    },

    setWhattsappProducts(checked) {
      this.form.whatsapp_products_status = checked
    },

    setCookiesNotification(checked) {
      this.form.cookies_notification = checked

      if (
        this.form.cookies_notification &&
        this.form.cookies_notification_text === ''
      ) {
        this.setDefaultCookiesNotificationText()
      }
    },

    setDefaultCookiesNotificationText() {
      this.form.cookies_notification_text =
        'Nós usamos cookies e outras tecnologias semelhantes para melhorar a sua experiência em nossos serviços. Ao utilizar nossos serviços, você concorda com tal monitoramento.'
    },

    async getSettings() {
      const data = await SettingsService.listAll()

      this.form = { ...this.settings, ...data }
      this.settings = cloneDeep(this.form)

      if (this.form.cookies_notification_position) {
        this.selectPosition(this.form.cookies_notification_position)
      }
    },

    resetForm() {
      this.form = cloneDeep(this.settings)
    },

    async send() {
      this.processing = true

      if (this.form.cookies_notification_text === '') {
        this.setDefaultCookiesNotificationText()
      }

      const data = this.form

      const response = await SettingsService.setSettings(data)

      if (response.status === 200) {
        this.$notify({
          group: 'notifications',
          type: 'success',
          text: 'Configurações salvas com sucesso'
        })
      } else {
        this.$notify({
          group: 'notifications',
          type: 'error',
          text: 'Erro ao salvar as configurações, tente novamente mais tarde.'
        })
      }

      this.processing = false
    },

    handleActiveTab(index) {
      this.activeTabIndex = index
    },

    /**
     * Verify and sets alignment of tabs component
     */
    handlerWindowSize() {
      const handler = () => {
        if (window.innerWidth <= 992) {
          this.variant = 'pills'
        } else {
          this.variant = 'tabs'
        }
      }

      window.addEventListener('resize', () => {
        handler()
      })

      handler()
    }
  }
}
</script>

<style lang="scss">
.website-tabs {
  .nav {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    flex-wrap: nowrap;

    .nav-item {
      a {
        white-space: nowrap;
      }
    }
  }
}

.informative {
  display: block;
  margin-top: 10px;
  padding: 15px 20px;
  background: #e1f3f8;
  border-radius: 0.25rem;
}

.span_description {
  color: #768192;
  margin-top: 0.25rem;
}

.preview-image {
  transform: translateX(-4%);

  img {
    width: 100%;
  }
}

.preview-select {
  display: flex;

  div {
    margin: 0px 10px;
    cursor: pointer;

    &:first-child {
      margin-left: 0px;
    }

    &:last-child {
      margin-right: 0px;
    }

    img {
      border: 2px solid $secondary-600;
    }

    &.active {
      img {
        border-color: $success;
      }
    }
  }
}
</style>
